import { $, HttpBody, Resp } from 'simpli-web-sdk'
import UploadDados from '@/model/resource/UploadDados'
import * as Helper from '@/helpers'
import { classToPlain } from 'class-transformer'
import FileResponse, { IFile } from '@/model/response/FileResponse'

export async function importFileToS3(request: any, idTipoUpload: number) {
    const json = JSON.stringify(classToPlain(request))

    const filename = Helper.uid()
    const preSignedUrl = async () => await new HttpBody(String).GET(`/user/upload-url/import?fileName=${filename}.json`)
    const url: Resp<String> = await $.await.run(preSignedUrl)

    await fetch(url.data as string, {
        method: 'PUT',
        mode: 'cors',
        credentials: 'omit',
        headers: {
            'content-type': 'application/octet-stream',
            'sec-fetch-mode': 'cors',
        },
        body: stringToArrayBuffer(json),
    })

    const upload = new UploadDados()
    if (url.data) {
        upload.urlArquivo = url.data.split('?')[0]
        upload.idTipoUploadFk = idTipoUpload
        await upload.inserirNaFila()
    }
}

export async function getPresignedUrlFromObjectUrl(objectUrl?: string): Promise<string> {
    if (objectUrl == null) {
        return "";
    }

    const preSignedUrl = async () => await new HttpBody(String).GET(`/user/upload-url/view-url?objectUrl=${objectUrl}`)
    const url: Resp<String> = await $.await.run(preSignedUrl)

    return url.data as string
}

const stringToArrayBuffer = (value: string) => {
    const encoder = new TextEncoder()
    return encoder.encode(value).buffer
}
